const __DEV__ = false;

function createMediaQueries(breakpoints) {
  return Object.keys(breakpoints).reduce(function (allMediaQueries, breakpoint) {
    var typedBreakpoint = breakpoint;
    var value = breakpoints[typedBreakpoint];
    var _ref = typeof value === 'string' ? {} : {
      prefix: '(min-width: ',
      suffix: 'px)'
    },
        _ref$prefix = _ref.prefix,
        prefix = _ref$prefix === void 0 ? '' : _ref$prefix,
        _ref$suffix = _ref.suffix,
        suffix = _ref$suffix === void 0 ? '' : _ref$suffix;
    allMediaQueries[typedBreakpoint] = "@media ".concat(prefix).concat(value).concat(suffix);
    return allMediaQueries;
  }, {});
}

export { createMediaQueries as default };
//# sourceMappingURL=createMediaQueries.js.map
